import { addRolesToUser, createMachineClient, deleteUser } from '@infuse/api/iam/user';
import { addRolesToOrganisationUser, createOrganisationMachineClient, deleteOrganisationUser } from '@infuse/api/iam/organisation';
import { addRolesToTenantUser, createTenantMachineClient, deleteTenantUser } from '@infuse/api/iam/tenant';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericCreateMachineUser } from './generic/useGenericCreateMachineUser';

export const useCreateMachineUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericCreateMachineUser({
      apiFn: createOrganisationMachineClient,
      roleApiFn: addRolesToOrganisationUser,
      deleteApiFn: deleteOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericCreateMachineUser({
      apiFn: createTenantMachineClient,
      roleApiFn: addRolesToTenantUser,
      deleteApiFn: deleteTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericCreateMachineUser({
    apiFn: createMachineClient,
    roleApiFn: addRolesToUser,
    deleteApiFn: deleteUser
  });
};
